
import { KnowledgeList } from "@/components/knowledge/KnowledgeList";
import { UploadKnowledgeForm } from "@/components/knowledge/upload/UploadKnowledgeForm";
import { useKnowledgeBase } from "@/components/knowledge/useKnowledgeBase";
import { useKnowledgeEntries } from "@/hooks/useKnowledgeEntries";
import { useUserRole } from "@/hooks/useUserRole";
import { useToast } from "@/hooks/use-toast";

const Knowledge = () => {
  const { invalidateEntries } = useKnowledgeEntries();
  const { isAdmin } = useUserRole();
  const { toast } = useToast();

  const handleEntryCreated = async () => {
    try {
      await invalidateEntries();
    } catch (error) {
      console.error('Error refreshing entries:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to refresh knowledge entries",
      });
    }
  };

  return (
    <div className="container py-8">
      <h1 className="text-2xl font-bold mb-8">Knowledge Management</h1>
      
      <div className="mb-6">
        {isAdmin && (
          <UploadKnowledgeForm onEntryCreated={handleEntryCreated} />
        )}
      </div>

      <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div className="flex flex-col space-y-1.5 p-6">
          <h3 className="text-2xl font-semibold leading-none tracking-tight">Knowledge Base</h3>
        </div>
        <div className="p-6 pt-0">
          <KnowledgeList />
        </div>
      </div>
    </div>
  );
};

export default Knowledge;
